import { Badge } from '../../../components/primitives/Badge';
import { useTranslation } from '../../../contexts/TranslationContext';
import type { VoiceCallOutcome } from '../types';

type BadgeColor = 'cyan' | 'green' | 'red' | 'amber' | 'purple' | 'blue' | 'neutral';

const OUTCOME_COLORS: Record<VoiceCallOutcome, BadgeColor> = {
  qualified: 'green',
  meeting_booked: 'green',
  not_qualified: 'neutral',
  do_not_call: 'neutral',
  callback_requested: 'amber',
  voicemail_left: 'amber',
  no_answer: 'red',
  technical_failure: 'red',
  incomplete: 'neutral',
};

interface OutcomeBadgeProps {
  outcome: VoiceCallOutcome | undefined | null;
  accessibilityLabel?: string;
  size?: 'sm' | 'md';
}

export function OutcomeBadge({ outcome, accessibilityLabel, size = 'sm' }: OutcomeBadgeProps) {
  const { t } = useTranslation();

  if (!outcome) {
    return (
      <Badge
        color="neutral"
        size={size}
        accessibilityLabel={accessibilityLabel ?? t('voiceAgents.outcome.none')}
      >
        —
      </Badge>
    );
  }

  const color = OUTCOME_COLORS[outcome] ?? 'neutral';
  const labelKey = `voiceAgents.outcome.${outcome}`;
  const resolved = t(labelKey);
  const label = resolved === labelKey ? outcome : resolved;

  return (
    <Badge
      color={color}
      size={size}
      accessibilityLabel={
        accessibilityLabel ?? `${t('voiceAgents.outcome.resultPrefix')}: ${label}`
      }
    >
      {label}
    </Badge>
  );
}
